import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CompanyConfiguration } from '@app-config/models/company-configuration';

import { AppointmentInfo } from '@appointments/store/models/appointment-info';
import { DateConstants } from '@core-constants/dates/date.constants';
import { ListingDetailsSectionName } from '@listings/enums/listing-details-section-name';
import { ListingDetailsNavigationParams } from '@listings/models/events/listing-details-navigation-params';
import { MediaViewerInitialParams } from '@media/components/media-viewer/models/media-viewer-initial-params';
import { GalleryListingCardComponent } from '../../../view-modules/view-base/components/gallery-listing-card/gallery-listing-card.component';
import { RpcIconComponent } from '../../../core-modules/utils/rpc-icon/rpc-icon.component';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TimePeriodLabelPipe } from '@core-pipes/time-period-label/time-period-label.pipe';

@Component({
    selector: 'landing-appointment-card',
    templateUrl: './landing-appointment-card.component.html',
    styleUrls: ['./landing-appointment-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GalleryListingCardComponent, RpcIconComponent, DatePipe, TranslateModule, TimePeriodLabelPipe]
})
export class LandingAppointmentCardComponent {
    @Input() public appointmentInfo: AppointmentInfo;
    @Input() public shouldHideOpenRentals: boolean;
    @Input() companyConfiguration: CompanyConfiguration;

    @Output() public mediaViewerClicked = new EventEmitter<MediaViewerInitialParams>();
    @Output() public listingDetailsClicked = new EventEmitter<ListingDetailsNavigationParams>();

    public readonly dateConstants = DateConstants;

    public onMediaViewerClicked(mediaViewerClickedEventParams: MediaViewerInitialParams): void {
        this.mediaViewerClicked.emit(mediaViewerClickedEventParams);
    }

    public onAppointmentCardClicked(): void {
        this.listingDetailsClicked.emit({ listingId: this.appointmentInfo.listing.id, tabId: ListingDetailsSectionName.Appointments });
    }
}
